import React from 'react';
import Link from '../Link';
import { Button, Tag } from 'antd';
import { CalendarOutlined } from '@ant-design/icons';
import './index.scss';

const LiveCard = ({ className, data, ...props }) => {

  const TagItem = (item, index) => {
    return (
      <Tag key={index} className={`com-item-tag`} color={item.type}>{item.text}</Tag>
    )
  }

  const Item = (item, index) => {

    return (
      <div className="com-live-card-item" key={index}>
        <div className={`com-live-card-item-avatar`}>
          <img
            src={item.pic}
            alt={item.title}
          />
        </div>

        <div className={`com-live-card-item-content`}>
          <div className={`com-live-card-item-title`}>
            {
              item.tags.length > 0 ?
                item.tags.map((tag, tagIndex) => {
                  return TagItem(tag, tagIndex);
                })
                : null
            }
            {item.title}
          </div>
          <div className={`com-live-card-item-sub-title`}>
            {item.subTitle}
          </div>
          <div className={`com-live-card-item-info`}>
            <div className={`com-live-card-item-date`}>
              <CalendarOutlined />
              {item.date}
            </div>
            <div className={`com-live-card-item-action`}>
              {item.applyNum}人已报名
              &nbsp;&nbsp;
              <Button
                className={`com-live-card-item-btn`}
                type="primary"
                size="small"
                shape="round"
              >
                去报名
              </Button>
            </div>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="com-live-card">
      <div className="com-live-card-title">
        {data.title}
        {
          data.more ?
            <Link className="com-live-card-more" href={data.more.url}>
              {data.more.text}
            </Link>
            : null
        }
      </div>
      <div className="com-live-card-list">
        {
          data.list.map((item, index) => (Item(item, index)))
        }
      </div>
    </div>
  )

}

export default LiveCard;

